"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvaluationTable = void 0;
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const Colors_1 = require("../../../../../Colors");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const common_1 = require("../../../../../common");
const etcButtonIcon = {
    show: true,
    name: 'fullArrow',
    width: 19,
    height: 11,
    color: Colors_1.Colors.grey,
};
const EvalTableStyled = styled_components_1.default.div `
	.table {
		width: 100%;
	}

	${props => (props.$isTablet ? tabletStyles : props.$isMobile ? mobileStyles : desktopStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	&.popup-list-001 {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		height: 100%;

		@keyframes shake {
			0% {
				transform: translateX(0);
			}
			25% {
				transform: translateX(-5px);
			}
			50% {
				transform: translateX(5px);
			}
			75% {
				transform: translateX(-3px);
			}
			100% {
				transform: translateX(3px);
			}
		}

		input.error {
			animation: shake 0.5s ease-in-out;

			background: #fff3f3;
			border-radius: 4px;
			border-style: solid;
			border-color: var(--color-accent, #e7424c);
			border-width: 1px;
			padding: 4px 10px 4px 10px;
			display: flex;
			flex-direction: row;
			gap: 10px;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
			position: relative;
			color: var(--color-accent, #e7424c);

			&:focus {
				border-radius: 4px;
				border-style: solid;
				border-color: var(--color-accent, #e7424c);
				border-width: 2px;
				outline: none;
			}
		}

		.table-header {
			width: 100%;
			background: var(--color-silver, #f3f4f8);
			border-style: solid;
			border-color: var(--color-grey-w, #b6bac0);
			border-width: 1px 0px 0px 0px;
			padding: 12px 5px;
			display: flex;
			flex-direction: row;
			gap: 12px;
			align-items: flex-start;
			justify-content: flex-start;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;

			color: var(--color-black, #101010);
			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 12px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 400;
			position: relative;
		}

		.scroll-content {
			width: 100%;
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 1px 0px 0px 0px;
			display: flex;
			flex-direction: column;
			gap: 0px;
			align-items: flex-start;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
			flex: 1;
			overflow: visible;
			padding: 0px 6px;

			input {
				padding: 6px 10px 6px 10px;

				text-align: left;
				font-family: 'Noto Sans KR', sans-serif;
				font-size: 12px;
				line-height: 150%;
				letter-spacing: -0.02em;
				font-weight: 400;
				position: relative;
				flex: 1;
				display: flex;
				align-items: center;
				justify-content: flex-start;
			}
		}

		.item {
			width: 100%;
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: 12px 0px 12px 0px;
			display: flex;
			flex-direction: row;
			gap: 6px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 12px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 400;
			position: relative;
		}
	}
`;
const tabletStyles = (0, styled_components_1.css) `
	&.popup-list-001 {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		height: 100%;

		@keyframes shake {
			0% {
				transform: translateX(0);
			}
			25% {
				transform: translateX(-5px);
			}
			50% {
				transform: translateX(5px);
			}
			75% {
				transform: translateX(-3px);
			}
			100% {
				transform: translateX(3px);
			}
		}

		input.error {
			animation: shake 0.5s ease-in-out;

			background: #fff3f3;
			border-radius: 4px;
			border-style: solid;
			border-color: var(--color-accent, #e7424c);
			border-width: 1px;
			padding: 4px 10px 4px 10px;
			display: flex;
			flex-direction: row;
			gap: 10px;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
			position: relative;
			color: var(--color-accent, #e7424c);

			&:focus {
				border-radius: 4px;
				border-style: solid;
				border-color: var(--color-accent, #e7424c);
				border-width: 2px;
				outline: none;
			}
		}

		.table-header {
			width: 100%;
			background: var(--color-silver, #f3f4f8);
			border-style: solid;
			border-color: var(--color-grey-w, #b6bac0);
			border-width: 1px 0px 0px 0px;
			padding: 12px 20px 12px 20px;
			display: flex;
			flex-direction: row;
			gap: 12px;
			align-items: flex-start;
			justify-content: flex-start;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;

			color: var(--color-black, #101010);
			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 12px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 400;
			position: relative;
		}

		.scroll-content {
			width: 100%;
			padding: 12px 0px 12px 0px;
			display: flex;
			flex-direction: column;
			gap: 12px;
			align-items: flex-start;
			justify-content: flex-start;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;

			color: var(--color-black, #101010);
			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 12px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 400;
			position: relative;
		}

		.item {
			width: 100%;
			padding: 0px 20px 10px 20px;
			display: flex;
			flex-direction: row;
			gap: 12px;
			align-items: center;
			justify-content: flex-start;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;
		}
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	&.popup-list-001 {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		height: 100%;

		@keyframes shake {
			0% {
				transform: translateX(0);
			}
			25% {
				transform: translateX(-5px);
			}
			50% {
				transform: translateX(5px);
			}
			75% {
				transform: translateX(-3px);
			}
			100% {
				transform: translateX(3px);
			}
		}

		input.error {
			animation: shake 0.5s ease-in-out;

			background: #fff3f3;
			border-radius: 4px;
			border-style: solid;
			border-color: var(--color-accent, #e7424c);
			border-width: 1px;
			padding: 4px 10px 4px 10px;
			display: flex;
			flex-direction: row;
			gap: 10px;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
			position: relative;
			color: var(--color-accent, #e7424c);

			&:focus {
				border-radius: 4px;
				border-style: solid;
				border-color: var(--color-accent, #e7424c);
				border-width: 2px;
				outline: none;
			}
		}

		.table-header {
			width: 100%;
			background: var(--color-silver, #f3f4f8);
			border-style: solid;
			border-color: var(--color-grey-w, #b6bac0);
			border-width: 1px 0px 0px 0px;
			padding: 10px 16px 10px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: flex-start;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
		}

		.scroll-content {
			width: 100%;
			display: flex;
			flex-direction: column;
			gap: 0px;
			align-items: flex-start;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
			flex: 1;
			overflow: visible;

			input {
				padding: 4px 10px 4px 10px;
			}
		}

		.item {
			width: 100%;
			padding: 8px 16px 8px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
		}
	}
`;
exports.EvaluationTable = react_1.default.memo(({ subject, isDefault, item, defaultEvalData, setEvalData, setTotalScore, }) => {
    const { isTablet, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const [key, setKey] = react_1.default.useState(0);
    const [page, setPage] = react_1.default.useState(0);
    const [testData, setTestData] = react_1.default.useState(defaultEvalData);
    const [totalCount, setTotalCount] = react_1.default.useState(0);
    const { headTitleList } = react_1.default.useMemo(() => {
        // 기본적인 항목들
        const headTitleList = [
            { title: 'no', space: 1, sort: false, maxWidth: isMobile ? 27 : 39 },
            { title: 'answer', space: 4, sort: false },
            { title: 'score', space: isTablet ? 1 : 2, sort: false },
            ...(isDefault
                ? []
                : [
                    { title: 'examples', space: 2, sort: false },
                    {
                        title: 'etc',
                        space: 1,
                        sort: false,
                        styles: { justifyContent: 'center' },
                    },
                ]),
        ];
        // useMemo에서 반환
        return { headTitleList };
    }, [isDefault]);
    react_1.default.useEffect(() => {
        if (defaultEvalData &&
            defaultEvalData.length > 0 &&
            !lodash_1.default.isEqual(defaultEvalData, testData)) {
            setKey(prevKey => prevKey + 1);
            setTestData(defaultEvalData);
            setTotalCount(defaultEvalData.length);
        }
    }, [defaultEvalData]);
    react_1.default.useEffect(() => {
        const totalScore = testData.reduce((acc, cur) => {
            return acc + cur.score;
        }, 0);
        setTotalScore({ id: item, total_score: totalScore });
    }, [item, testData]);
    react_1.default.useEffect(() => {
        setEvalData((prevData) => {
            const dupDataIndex = prevData.findIndex((data) => data.key === item);
            // 새로운 항목을 추가하는 경우
            if (dupDataIndex === -1) {
                return [...prevData, { data: testData, key: item }];
            }
            // 기존 항목을 업데이트하는 경우
            else {
                const newData = [...prevData];
                newData[dupDataIndex] = { data: testData, key: item };
                return newData;
            }
        });
    }, [testData]);
    const moveItem = (item, direction) => {
        let moved = false;
        //@ts-ignore
        setTestData(prevData => {
            const index = prevData.findIndex(data => data.id === item.id);
            if (index === -1)
                return prevData;
            const targetIndex = direction === 'up' ? index - 1 : index + 1;
            // 이동할 수 없는 경우 이전 상태 그대로 반환
            if (targetIndex < 0 || targetIndex >= prevData.length) {
                return prevData;
            }
            // 항목 객체 전체(정답/성적/선지 개수/타입 등)를 통째로 교환한다.
            // 기존 구현은 id(=No)만 swap 후 정렬해, 비제어(input defaultValue) 셀이
            // 위치에 고정돼 정답/성적은 그대로 남고 선지 개수만 이동하던 문제가 있었다.
            const newData = [...prevData];
            [newData[index], newData[targetIndex]] = [
                newData[targetIndex],
                newData[index],
            ];
            // No(순번=id)는 위치 고정 — 각 위치의 id를 원래 순서대로 재부여한다.
            const reIndexed = newData.map((data, i) => ({
                ...data,
                id: prevData[i].id,
            }));
            moved = true;
            return reIndexed;
        });
        // 비제어 input(defaultValue) 셀이 바뀐 순서를 반영하도록 테이블을 강제 리마운트
        if (moved) {
            setKey(prevKey => prevKey + 1);
        }
    };
    // (onChange) 변경된 값 저장
    const onChange = (id, value) => {
        //@ts-ignore
        setTestData((prevData) => {
            const newData = [...prevData];
            const index = prevData.findIndex(data => data.id === id);
            if (index !== -1) {
                newData[index] = {
                    ...newData[index],
                    ...value,
                };
            }
            return newData;
        });
    };
    const renderItem = react_1.default.useMemo(() => (item, styles, itemIndex) => {
        return (react_1.default.createElement(EvaluationItem, { isDefault: isDefault, item: item, styles: styles, itemIndex: itemIndex, lastIndex: totalCount - 1 === itemIndex, moveItem: moveItem, onChange: onChange, subject: subject, isNumber: subject.includes('math') }));
    }, [isDefault, subject, onChange]);
    return (react_1.default.createElement(EvalTableStyled, { "$isTablet": isTablet, "$isMobile": isMobile, id: "eval_table", className: "popup-list-001" },
        react_1.default.createElement(common_1.Table, { key: key, showCheckBox: false, showIndex: false, isInfinite: true, data: testData, totalCount: totalCount, page: page, sortDefault: "id", headTitleList: headTitleList, renderItem: renderItem })));
});
const EvaluationItem = react_1.default.memo(({ isDefault, item, styles, itemIndex, lastIndex, moveItem, onChange, subject, isNumber, }) => {
    const { isTablet, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const examplesRef = react_1.default.useRef(null);
    const answerRef = react_1.default.useRef(null);
    const scoreRef = react_1.default.useRef(null);
    const [firstErrorCheck, setFirstErrorCheck] = react_1.default.useState(false);
    const [error, setError] = react_1.default.useState({
        answer: false,
        score: false,
        examples: false,
    });
    const { tableReadDataKeys } = react_1.default.useMemo(() => {
        const tableReadDataKeys = [
            { title: 'no', space: 1, maxWidth: isMobile ? 27 : 39 },
            { title: 'answer', space: 4 },
            { title: 'score', space: isTablet ? 1 : 2 },
            ...(isDefault
                ? []
                : [
                    { title: 'examples', space: 2 },
                    { title: 'etc', space: 1 },
                ]),
        ];
        // useMemo에서 반환
        return { tableReadDataKeys };
    }, [isDefault]);
    const handlerErrorCheck = () => {
        if (!firstErrorCheck) {
            setFirstErrorCheck(true);
        }
        checkError();
    };
    const checkError = () => {
        let changeError = { ...error };
        const element = answerRef.current;
        const scoreElement = scoreRef.current;
        const examplesElement = examplesRef.current;
        if (element) {
            const value = element.value.trim();
            if (item.type === 'subjective' || item.type === 'short') {
                changeError.answer = value === undefined || value === '' || value.length > 500;
            }
            else {
                const answer = Number(value);
                const examples = Number(examplesElement?.value) || item.examples;
                changeError.answer =
                    value === undefined ||
                        value === '' ||
                        isNaN(answer) ||
                        answer > examples ||
                        answer <= 0;
            }
        }
        if (scoreElement) {
            const value = scoreElement.value.trim();
            const score = Number(scoreElement.value.trim());
            changeError.score =
                value === undefined || value === '' || isNaN(score) || score <= 0;
        }
        if (examplesElement) {
            const value = scoreElement.value.trim();
            const examples = Number(examplesElement.value.trim());
            changeError.examples =
                value === undefined ||
                    value === '' ||
                    isNaN(examples) ||
                    examples <= 0 ||
                    examples > 10;
        }
        setError(changeError);
    };
    react_1.default.useEffect(() => {
        APP.eventManager.subscribe('CHECK_ERROR', handlerErrorCheck);
        return () => {
            APP.eventManager.unsubscribe('CHECK_ERROR', handlerErrorCheck);
        };
    }, []);
    react_1.default.useEffect(() => {
        setFirstErrorCheck(false);
        setError({
            answer: false,
            score: false,
            examples: false,
        });
    }, [subject]);
    react_1.default.useEffect(() => {
        if (scoreRef.current) {
            scoreRef.current.value = item.score.toString() || '2';
        }
        if (firstErrorCheck)
            checkError();
    }, [item.score]);
    react_1.default.useEffect(() => {
        // const element = answerRef.current;
        // if (element) {
        // 	const value = element.value;
        // 	if (item.answer !== value) {
        // 		element.value = item.answer;
        // 	}
        // }
        // console.log('element.value', element.value);
        if (firstErrorCheck)
            checkError();
    }, [item.answer]);
    react_1.default.useEffect(() => {
        const element = examplesRef.current;
        if (element) {
            const value = element.value;
            if (item.examples && item.examples.toString() !== value) {
                element.value = item.examples.toString();
            }
        }
        if (firstErrorCheck)
            checkError();
    }, [item.examples]);
    const moveItemUp = (item) => moveItem(item, 'up');
    const moveItemDown = (item) => moveItem(item, 'down');
    const numberCheck = isNumber ? isNumber : item.type === 'objective' ? true : false;
    return (react_1.default.createElement(react_1.default.Fragment, null, tableReadDataKeys.map((headItem, index) => (react_1.default.createElement("div", { key: item.id + '-' + headItem.title, id: item.id + headItem.title, style: {
            flex: headItem.space,
            ...styles?.bodyItem,
            ...(headItem.maxWidth && { maxWidth: headItem.maxWidth }),
            overflow: 'hidden',
        } }, headItem.title === 'no' ? (react_1.default.createElement("p", null, item.id)) : headItem.title === 'etc' ? (react_1.default.createElement("div", { className: "flex column", style: { gap: 4, alignItems: 'center' } },
        react_1.default.createElement(common_1.Button, { className: `full-arrow-up ${itemIndex === 0 ? 'disable' : 'able'}`, onClick: () => moveItemUp(item), tablIndex: -1, option: {
                buttonBeforeIcon: etcButtonIcon,
            } }),
        react_1.default.createElement(common_1.Button, { className: `full-arrow-down ${lastIndex ? 'disable' : 'able'}`, onClick: () => moveItemDown(item), tablIndex: -1, option: {
                buttonBeforeIcon: etcButtonIcon,
            } }))) : headItem.title === 'examples' &&
        (item.type === 'subjective' || item.type === 'short') ? ('-') : (react_1.default.createElement("div", null,
        react_1.default.createElement(common_1.InputElement, { className: `${error[headItem.title] ? 'error' : ''}`, ref: headItem.title === 'score'
                ? scoreRef
                : headItem.title === 'answer'
                    ? answerRef
                    : headItem.title === 'examples'
                        ? examplesRef
                        : undefined, defaultValue: headItem.title === 'score'
                ? item.score
                : headItem.title === 'answer'
                    ? item.answer
                    : item.examples, 
            // value={
            // 	headItem.title === 'score'
            // 		? item.score
            // 		: headItem.title === 'answer'
            // 		? item.answer
            // 		: item.examples
            // }
            type: headItem.title === 'answer' ? 'text' : 'number', min: headItem.title === 'score' || item.type === 'objective'
                ? 1
                : undefined, style: styles?.bodyText, tabIndex: headItem.title === 'score' ? -1 : 0, isNumber: numberCheck, maxNumLen: isNumber && headItem.title === 'answer'
                ? headItem.title === 'answer'
                    ? item.type === 'objective'
                        ? 5
                        : 5
                    : undefined
                : undefined, onChange: value => {
                let data = undefined;
                try {
                    data =
                        headItem.title === 'score' ||
                            headItem.title === 'examples'
                            ? value * 1
                            : value;
                }
                catch { }
                onChange(item.id, {
                    [headItem.title]: data,
                });
            } }))))))));
});
// React.useEffect(() => {
// 	if (scoreBlank) {
// 		const pervScore = testData.map(item => {
// 			return { id: item.id, score: item.score };
// 		});
// 		setPrevScoreData(pervScore);
// 		// @ts-ignore
// 		setTestData(prevData => {
// 			return prevData.map(item => {
// 				return { ...item, score: 0 };
// 			});
// 		});
// 	} else {
// 		if (prevScoreData && prevScoreData.length > 0) {
// 			//@ts-ignore
// 			setTestData(prevData => {
// 				return prevData.map(item => {
// 					const pervScore = prevScoreData.find(
// 						scoreData => scoreData.id === item.id
// 					);
// 					return { ...item, score: pervScore?.score || 0 };
// 				});
// 			});
// 		}
// 	}
// }, [scoreBlank]);
